import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/reportingCycles'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { Main, MainTop, MainTopTitle, MainBody, WhiteBox } from '@/components/Layout'
import { Row, Col } from 'reactstrap'
import { localized } from '@/decorators/localized'
import LoadingIndicator from '@/components/LoadingIndicator'
import { ReportingCyclesSubmissions } from './submissions'
import { ReportingCycleDetailForm } from './form'
import DetailCollisionDates from './collisionDates/detailCollisionDates'
import find from 'lodash/find'
import { withPermissions } from '@/decorators/withPermissions'

@localized()
@withPermissions()
class ReportingCyclesDetail extends React.Component {
  componentDidMount () {
    this.props.get(this.props.match.params.id)
  }
  componentDidUpdate (prevProps, prevState) {
    const shouldLoad = (this.props.match.params.id !== prevProps.match.params.id)
    if (shouldLoad) { this.props.get(this.props.match.params.id) }
  }
  canManage () { return this.props.isGranted('CanManageReportingCalendars') }
  currentReportingCycleId () {
    return Number(this.props.match.params.id)
  }
  renderReportingCycleEditor (reportingCycles, year) {
    const isLoading = reportingCycles.creating || reportingCycles.retrieving || reportingCycles.reportingCycle == null
    if (isLoading) { return <LoadingIndicator /> }

    return (
      <ReportingCycleDetailForm
        key={reportingCycles.componentKey}
        reportingCycle={reportingCycles.reportingCycle}
        year={year}
        disabled={!this.canManage()}
        localize={this.props.localize}
        onSave={data => this.props.create(data)}
      />
    )
  }
  render () {
    const year = { number: this.props.match.params.year }
    const { localize, reportingCycles } = this.props
    const reportingCycle = (reportingCycles.reportingCycle || {})
    const reportingCycleId = this.currentReportingCycleId()
    const reportingCycleCollisions = find(this.props.reportingCycleCollisions.collisionDates, x => x.reportingCycleId === reportingCycleId)
    return (
      <React.Fragment>
        <Main>
          <MainTop>
            <MainTopTitle backUrl={`/reporting-calendars/${year.number}/reporting-cycles`}>{localize('Reporting.ReportingCycleDetail')}</MainTopTitle>
          </MainTop>
          <MainBody transparent>
            <WhiteBox>
              <Row>
                <Col className='col-md-7'>
                  {this.renderReportingCycleEditor(reportingCycles, year)}
                </Col>
                <DetailCollisionDates
                  localize={localize}
                  reportingCycleId={reportingCycleId}
                  isLoading={reportingCycles.retrieving} />
              </Row>
            </WhiteBox>
            <WhiteBox>
              {reportingCycles.retrieving && <LoadingIndicator />}
              {!reportingCycles.retrieving && <ReportingCyclesSubmissions
                localize={localize}
                disabled={!this.canManage()}
                reportingCycleId={reportingCycleId}
                reportingCycleCollisions={reportingCycleCollisions}
                reportingCycle={reportingCycle}
                update={this.props.update}
                openDialog={this.props.openDialog}
              />}
            </WhiteBox>
          </MainBody>
        </Main>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    reportingCycles: state.reportingCycles,
    reportingCycleCollisions: state.reportingCycleCollisions,
    ...ownProps
  }
}

const mapDispatchToProps = {
  get: actionCreators.get,
  update: actionCreators.update,
  create: actionCreators.create,
  openDialog: dialogActions.openDialog
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportingCyclesDetail)



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportingCycles/detail.js